import {
  Box,
  Container,
  Divider,
  Link as MuiLink,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';

import { Logo } from '@/components/Logo/Logo';
import { useAuth } from '@/hooks/useAuth';

const ADDRESS = '813 SW 16th Ct, Fort Lauderdale, FL 33315';
const PHONE = '954-466-1614';
const PHONE_HREF = 'tel:+19544661614';
const EMAIL = 'support@unbeatableloans.com';

export const MarketingSiteFooter = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 4, md: 5 },
        mt: 'auto',
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: 3 }}>
          <Logo variant="footer" />
        </Box>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2 }}>
          Quick info
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          {ADDRESS}
        </Typography>
        <MuiLink
          href={`mailto:${EMAIL}`}
          variant="body2"
          display="block"
          sx={{ mb: 0.5 }}
        >
          {EMAIL}
        </MuiLink>
        <MuiLink
          href={PHONE_HREF}
          variant="body2"
          display="block"
          sx={{ mb: 2 }}
        >
          {PHONE}
        </MuiLink>
        <Divider sx={{ my: 2 }} />
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: { xs: 1, sm: 2 },
            alignItems: 'center',
          }}
        >
          <Typography
            component={Link}
            to="/terms-of-service"
            variant="body2"
            color="primary"
          >
            Terms of Service
          </Typography>
          <Typography variant="body2" color="text.disabled">
            |
          </Typography>
          <Typography
            component={Link}
            to="/privacy-policy"
            variant="body2"
            color="primary"
          >
            Privacy Policy
          </Typography>
          <Typography variant="body2" color="text.disabled">
            |
          </Typography>
          <Typography
            component={Link}
            to="/licensing"
            variant="body2"
            color="primary"
          >
            Licensing
          </Typography>
          <Typography variant="body2" color="text.disabled">
            |
          </Typography>
          <Typography
            component={Link}
            to="/blog"
            variant="body2"
            color="primary"
          >
            Blog
          </Typography>
          <Typography variant="body2" color="text.disabled">
            |
          </Typography>
          <Typography
            component={Link}
            to="/about-unbeatable"
            variant="body2"
            color="primary"
          >
            About
          </Typography>
          {!isAuthenticated ? (
            <>
              <Typography variant="body2" color="text.disabled">
                |
              </Typography>
              <Typography
                component={Link}
                to="/careers"
                variant="body2"
                color="primary"
              >
                Careers
              </Typography>
            </>
          ) : null}
        </Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 2 }}
        >
          Thank you for choosing Unbeatable Loans. We are dedicated to helping
          you achieve your homeownership goals with personalized service and
          expert guidance.
        </Typography>
      </Container>
    </Box>
  );
};
